import { render } from "./LicenseStatusEmailSettingsCard.vue?vue&type=template&id=12c29114&scoped=true"
import script from "./LicenseStatusEmailSettingsCard.vue?vue&type=script&lang=js"
export * from "./LicenseStatusEmailSettingsCard.vue?vue&type=script&lang=js"

import "./LicenseStatusEmailSettingsCard.vue?vue&type=style&index=0&id=12c29114&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c29114"]])

export default __exports__